import { registerComponent, getComponentConfig } from "helpers";

/**
 * 1. TODO: Make this line conditional based on recent view type.
 *    We're only using `product` type currently, so punting on figuring out the best solution for that.
 */

registerComponent(
  "recent-views",
  class RecentViews extends HTMLElement {
    static observedAttributes = ["has-views"];

    constructor() {
      super();

      this.config = getComponentConfig(this);
      this.section = this.closest(".shopify-section");

      this.allViews = JSON.parse(localStorage.getItem("wyattRecentViews"));
      this.views = this.allViews ? this.allViews[this.config.type] : [];

      if (this.views?.length) {
        this.views.slice(0, this.config.max).forEach(this.getView.bind(this));
      }
    }

    attributeChangedCallback(attribute, oldValue, newValue) {
      if (attribute === "has-views") {
        const addOrRemove = newValue === "true" ? "remove" : "add";

        this.section.classList[addOrRemove]("hidden");
      }
    }

    async getView(view) {
      const url = `${WYATT.routes.root}products/${view.handle}?view=recent-view`; /* [1] */

      const response = await fetch(url);

      if (response.ok) {
        const html = await response.text();
        this.renderView(html);
        this.setAttribute("has-views", true);
      }
    }

    renderView(html) {
      const gridCell = document.createElement("div");

      gridCell.classList.add("recent-views__item");
      gridCell.innerHTML = html;

      this.updateSizes(gridCell); /* [1] */

      this.appendChild(gridCell);
    }

    updateSizes(gridCell) {
      const images = gridCell.querySelectorAll("[sizes]");
      let sizes = "";

      if (this.config.fullWidth) {
        sizes = `(min-width: ${WYATT.config.breakPoints.wide}px) calc(100vw / ${this.config.columns}), (min-width: ${WYATT.config.breakPoints.medium}px) 25vw, 50vw`;
      } else {
        sizes = `(min-width: ${WYATT.config.breakPoints.wide}px) calc(${WYATT.config.breakPoints.wide}px / ${this.config.columns}), (min-width: ${WYATT.config.breakPoints.medium}px) 25vw, 50vw`;
      }

      images.forEach((image) => image.setAttribute("sizes", sizes));
    }
  }
);
